import React from 'react';
import { ChevronRight, ShieldCheck } from 'lucide-react';
// Enlace directo al carrito de Shopify. Formato permalink /cart/{variantId}:{cantidad}
// Agrega el producto y lleva al cliente directo al carrito, sin rebotes.
export const CART_VARIANT_ID = '47794369921163';
export const CTA_LINK = `https://labibliadelbacktest.shop/cart/${CART_VARIANT_ID}:1`;
export const BOOK_COVER = 'https://cdn.magicpatterns.com/uploads/5zndJKREMUkCuHo3cNKBRX/ChatGPT_Image_Jul_2,_2026,_01_59_25_PM.png';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  showIcon?: boolean;
}
export function CTAButton({
  children,
  variant = 'primary',
  size = 'lg',
  className = '',
  showIcon = true,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-heading font-bold rounded-lg transition-all duration-300 transform hover:-translate-y-1 hover:shadow-xl text-center';
  const variants = {
    primary: 'bg-brand-500 hover:bg-brand-600 text-white shadow-brand-500/25',
    secondary: 'bg-white hover:bg-gray-100 text-gray-900',
    outline: 'border-2 border-brand-500 text-brand-500 hover:bg-brand-500 hover:text-white'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl',
    xl: 'px-10 py-5 text-xl md:text-2xl w-full md:w-auto'
  };
  return <div className="flex flex-col items-center w-full md:w-auto" data-id="element-170">
      <a href={CTA_LINK} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-171">
        {children}
        {showIcon && <ChevronRight className="ml-2 w-6 h-6" data-id="element-172" />}
      </a>
      {size === 'xl' && <div className="flex items-center mt-3 text-sm text-gray-400 font-medium" data-id="element-173">
          <ShieldCheck className="w-4 h-4 mr-1 text-brand-500" data-id="element-174" />
          Pago 100% Seguro y Acceso Inmediato
        </div>}
    </div>;
}
export function Section({
  children,
  className = '',
  darker = false,
  id = ''
}: {
  children: React.ReactNode;
  className?: string;
  darker?: boolean;
  id?: string;
}) {
  return <section id={id} className={`py-20 md:py-32 px-4 sm:px-6 lg:px-8 ${darker ? 'bg-dark-bg' : 'bg-dark-card'} ${className}`} data-id="element-175">
      <div className="max-w-6xl mx-auto" data-id="element-176">{children}</div>
    </section>;
}